import service from "../util/http";
import request from "../util/request";
import requestBx from "../util/bx";


//问卷列表
export const surveyLs = (data) => {
  return service({
    url: "/customer/survey/list",
    method: "post",
    data,
  });
};